<div class=" header bg-gradient-nhc-orange pb-6">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
        <div class=" col-lg-12 col-12">
          <nav
            aria-label="breadcrumb"
            class=" d-none d-md-inline-block ml-md-4"
          >
            <ol class=" breadcrumb breadcrumb-links breadcrumb-dark">
              <li class=" breadcrumb-item">
                <a [routerLink]="['/']" href="javascript:void(0)">
                  <i class=" fas fa-home"></i>
                </a>
              </li>

              <li class=" breadcrumb-item">
                <a [routerLink]="['/funding-opportunities']" href="javascript:void(0)"> Funding opportunities </a>
              </li>


              <li class=" breadcrumb-item">
                <a href="javascript:void(0)"> {{ projectData.projectName }} </a>
              </li>
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)"> Project Grant Application </a>
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>

<div class=" container-fluid mt--6">
  <section class="section" id="project-detail">
    <div class="row">
      <div class="col-lg-8 col-md-12 col-sm-12">
        <div class=" card-wrapper" id="projectInfo">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-md-9 col-lg-9 col-sm-12">
                  <h3 class=" mb-0">Project Information</h3>
                </div>
              </div>


            </div>
            <div class="card-body">

              <div class="form-group">
                <h4>Name</h4>
                <p class="text-muted">{{ projectData.projectName }}</p>
              </div>
              <div class="form-group">
                <h4>Description</h4>
                <p class="text-muted">{{ projectData.projectDescription }}</p>
              </div>
              <div class="row">
                <div class="form-group  col-lg-4 col-md-4 col-sm-12">
                  <h4>Budget Frame</h4>
                  <p
                    class="text-muted">{{ projectData.budgetFrame|number:'1.00' }}{{ " " }}{{ projectData.currencyCode }}</p>
                </div>
                <div class="form-group  col-lg-4 col-md-4 col-sm-12">
                  <h4>Application Deadline</h4>
                  <p class="text-muted">{{ projectData.dueDate|date:'dd/MM/yyyy' }}</p>
                </div>
                <div class="form-group  col-lg-4 col-md-4 col-sm-12">
                  <h4>Type of support</h4>
                  <ul style="list-style: none; padding-left: 0" class="text-muted">
                    <li *ngFor="let support of projectData.typeOfSupports">
                      {{ support.trim() }}
                    </li>
                  </ul>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-9 col-lg-9 col-sm-12">
                <h3 class=" mb-0">Documents</h3>
              </div>
            </div>
          </div>

          <div [formGroup]="fileForm" class="card-body">
            <p class="text-muted small ">
              Upload application form and budget files (mandatory)
            </p>
            <app-upload-form
              [data]="files"
              [documentDatas]="documentDatas"
              [parentForm]="fileForm"
            >
            </app-upload-form>
          </div>
        </div>
      </div>
    </div>

  </section>

  <app-project-form-detail [granApplicationId]="granApplicationId"
                           [documentDatas]="documentDatas"
                           [projectId]="projectId"
                           (filesChanged)="onFileValueChanged($event)"
  > </app-project-form-detail>
</div>
